import {NavTarget} from "../link/link.component";
import {calculateParallelHistInfos, calculateSerialHistInfos} from "../../functions/history.functions";
import {Subscription} from "rxjs";
import {ListLoader} from "../list-loader/list-loader";
import {Directive, OnDestroy} from "@angular/core";

@Directive()
export abstract class AbstractComponent implements OnDestroy {

  public navTargets = NavTarget;
  public subscriptions = new Array<Subscription>();
  public listLoaders = new Array<ListLoader<any>>();

  public parallelHistInfos = calculateParallelHistInfos;
  public serialHistInfos = calculateSerialHistInfos;

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    for (const listLoader of this.listLoaders) {
      listLoader.unsubscribeAll();
    }
  }

  addSub(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  addLoader(listLoader: ListLoader<any>) {
    this.listLoaders.push(listLoader);
  }
}
